
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[sort_url]",
      function () {
        return require("private-next-pages/news/[sort_url].js");
      }
    ]);
  